/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import { ISpacerViewProps } from './spacer';

const SpacerView: React.FC<ISpacerViewProps> = props => (
    <div className={props.className} id={props.id} {...props.renderModuleAttributes(props)} />
);

export default SpacerView;
